import React from 'react'
import { textStyles } from '@marketing-sites/ui'
import type { RichTextHyperlinkToEntryFragment } from '../../../.graphql/generated-types'
import { LinkToArticlePage } from '../LinkToArticlePage'

export interface RichTextHyperlinkToEntryProps {
  data: RichTextHyperlinkToEntryFragment
  children: React.ReactNode
}

export function RichTextHyperlinkToEntry({
  data,
  children,
}: RichTextHyperlinkToEntryProps): JSX.Element {
  switch (data.__typename) {
    case 'ComposePageArticle':
      return (
        <LinkToArticlePage article={data} className={textStyles.a}>
          {children}
        </LinkToArticlePage>
      )
    default:
      return <div></div>
  }
}
